<template>
  <ControlUnit :title="$t('control.panel.widget_icon')">
    <InputSelect
      :name="unitName"
      :value="currentIconMode"
      :options="iconModes"
      @change="changeHandler"
    />

    <IconModeImage
      v-if="currentIconMode === 'image'"
    />
    
  </ControlUnit>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';

import { runAllWithData } from '@/helpers/functional';

import useStateController from './useStateController';
import useRouteController from './useRouteController';

import ControlUnit from './ControlUnit.vue';
import InputSelect from './InputSelect.vue';

import IconModeImage from './IconModeImage.vue';

export default {
  components: {
    ControlUnit,
    InputSelect,
    IconModeImage,
  },
  setup() {
    const unitName = 'icon-mode';    

    const store = useStore();

    const iconModes = store.state.control.iconModes;

    const currentIconMode = computed(() => {
      return store.state.control.currentIconMode;
    });

    const { changeControlHandler } = useStateController();

    const { setRouteTypeValue, getRouterQueryValue } =
      useRouteController('Control');

    const changeHandler = runAllWithData(
      changeControlHandler,
      setRouteTypeValue
    );

    onMounted(() => {
      const unitQueryValue = getRouterQueryValue(unitName);

      changeControlHandler({
        type: unitName,
        value: unitQueryValue,
      });
    });

    return {
      unitName,
      iconModes,
      currentIconMode,
      changeHandler,
    };
  },
};
</script>
